import React from 'react';
import { X } from 'lucide-react';
import clsx from 'clsx';

export const Banner = ({ 
  children, 
  onAccept, 
  onDismiss, 
  acceptText = "Accept",
  className,
  ...props 
}) => {
  return (
    <div 
      className={clsx(
        'fixed bottom-0 left-0 right-0 bg-slate-800 border-t border-slate-700 p-4 z-50 shadow-lg',
        className
      )}
      {...props}
    >
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        <div className="flex-1 pr-4 mb-4 md:mb-0">
          {children}
        </div>
        
        <div className="flex items-center space-x-4">
          <button 
            onClick={onAccept} 
            className="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
          >
            {acceptText}
          </button>
          
          <button 
            onClick={onDismiss} 
            className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 rounded"
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};